"use strict";
// Raw aspect-ratio helper. The run-level facet-label bucketing that used to live
// here (aspectRatioLabel / resolutionLabel / facetLabelsFromResults) fed the
// retired Firestore facet filter + label stamping and was removed with them. The
// Library Filter now computes its aspect/resolution buckets in Postgres at sync
// time — the canonical bucketing is restServer/runnit/library_facets_compute.py
// (see CONTEXT.md *Facet Column* / ADR 0018).
//
// queueGpuJobs keeps a hand-synced copy of computeAspectRatio
// (queueGpuJobs/src/utils/aspectRatio.ts) because it can't import this package
// in its flat Heroku slug — keep the two identical if you change the formula.
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeAspectRatio = computeAspectRatio;
function computeAspectRatio(width, height) {
    if (!width || !height || width <= 0 || height <= 0)
        return null;
    return Math.round((width / height) * 10000) / 10000;
}
